import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';

export const WrapperStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '4px',
  padding: '13px 16px',
  border: `1px solid ${theme.palette.action.disabled}`,
  justifyContent: 'space-between',
}));

export const ContentStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

export const RowStyled = styled(Box)({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  gap: '4px',
});
